module.exports = __webpack_public_path__ + "img/3e_Attendance.6e900400.png";